import { template as template_c33a143cfc684ca68672f202f6047213 } from "@ember/template-compiler";
import PowerSelectMultiple from 'eflex/components/power-select-multiple';
import { get } from '@ember/helper';
export default template_c33a143cfc684ca68672f202f6047213(`
<PowerSelectMultiple
  @afterOptionsComponent={{@afterOptionsComponent}}
  @allowClear={{@allowClear}}
  @animationEnabled={{@animationEnabled}}
  @ariaDescribedBy={{@ariaDescribedBy}}
  @ariaInvalid={{@ariaInvalid}}
  @ariaLabel={{@ariaLabel}}
  @ariaLabelledBy={{@ariaLabelledBy}}
  @beforeOptionsComponent={{@beforeOptionsComponent}}
  @buildSelection={{@buildSelection}}
  @calculatePosition={{@calculatePosition}}
  @class={{@class}}
  @closeOnSelect={{@closeOnSelect}}
  @defaultHighlighted={{@defaultHighlighted}}
  @destination={{@destination}}
  @disabled={{@disabled}}
  @dropdownClass={{@dropdownClass}}
  @eventType={{@eventType}}
  @extra={{@extra}}
  @groupComponent={{@groupComponent}}
  @highlightOnHover={{@highlightOnHover}}
  @horizontalPosition={{@horizontalPosition}}
  @initiallyOpened={{@initiallyOpened}}
  @loadingMessage={{@loadingMessage}}
  @matcher={{@matcher}}
  @matchTriggerWidth={{@matchTriggerWidth}}
  @noMatchesMessage={{@noMatchesMessage}}
  @onBlur={{@onBlur}}
  @onChange={{@onChange}}
  @onClose={{@onClose}}
  @onFocus={{@onFocus}}
  @onInput={{@onInput}}
  @onKeydown={{@onKeydown}}
  @onOpen={{@onOpen}}
  @options={{@options}}
  @optionsComponent={{@optionsComponent}}
  @placeholder={{@placeholder}}
  @placeholderComponent={{@placeholderComponent}}
  @preventScroll={{@preventScroll}}
  @registerAPI={{@registerAPI}}
  @renderInPlace={{@renderInPlace}}
  @scrollTo={{@scrollTo}}
  @search={{@search}}
  @searchEnabled={{@searchEnabled}}
  @searchField={{if (has-block) @searchField (if @searchField @searchField @optionLabelPath)}}
  @searchMessage={{@searchMessage}}
  @searchPlaceholder={{@searchPlaceholder}}
  @searchFieldPosition={{@searchFieldPosition}}
  @selected={{@value}}
  @selectedItemComponent={{@selectedItemComponent}}
  @tabindex={{@tabindex}}
  @triggerClass={{@triggerClass}}
  @triggerComponent={{@triggerComponent}}
  @triggerId={{@triggerId}}
  @triggerRole={{@triggerRole}}
  @typeAheadMatcher={{@typeAheadMatcher}}
  @verticalPosition={{@verticalPosition}}
  ...attributes
as |item select|>
  {{#if (has-block)}}
    {{yield item select}}
  {{else}}
    {{#if @optionLabelPath}}
      {{get item @optionLabelPath}}
    {{else}}
      {{item}}
    {{/if}}
  {{/if}}
</PowerSelectMultiple>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
